import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { 
      title: '登录',
      requiresAuth: false 
    }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { 
      title: '首页',
      requiresAuth: true,
      hideLayout: true
    }
  },
  {
    path: '/admin',
    component: () => import('@/layout/index.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminList',
        component: () => import('@/views/admin/AdminList.vue'),
        meta: { 
          title: '管理员列表',
          requiresAuth: true 
        }
      },
      {
        path: 'stores',
        name: 'StoreOnlyList',
        component: () => import('@/views/store/StoreOnlyList.vue'),
        meta: { 
          title: '门店列表',
          requiresAuth: true 
        }
      },
      {
        path: 'agents',
        name: 'AgentList',
        component: () => import('@/views/store/AgentList.vue'),
        meta: { 
          title: '代理列表',
          requiresAuth: true 
        }
      },
      {
        path: 'store-applications',
        name: 'StoreApplicationList',
        component: () => import('@/views/store/StoreApplicationList.vue'),
        meta: { 
          title: '门店申请管理',
          requiresAuth: true 
        }
      },
      {
        path: 'stores/:id',
        name: 'StoreDetail',
        component: () => import('@/views/store/StoreDetail.vue'),
        meta: { 
          title: '门店详情',
          requiresAuth: true 
        }
      },
      {
        path: 'products',
        name: 'ProductList',
        component: () => import('@/views/product/ProductList.vue'),
        meta: { 
          title: '商品管理',
          requiresAuth: true 
        }
      },
      {
        path: 'products/create',
        name: 'ProductCreate',
        component: () => import('@/views/product/ProductForm.vue'),
        meta: { 
          title: '新增商品',
          requiresAuth: true 
        }
      },
      {
        path: 'products/:id',
        name: 'ProductDetail',
        component: () => import('@/views/product/ProductDetail.vue'),
        meta: { 
          title: '商品详情',
          requiresAuth: true 
        }
      },
      {
        path: 'products/:id/edit',
        name: 'ProductEdit',
        component: () => import('@/views/product/ProductForm.vue'),
        meta: { 
          title: '编辑商品',
          requiresAuth: true 
        }
      },
      {
        path: 'coupons/templates',
        name: 'CouponTemplateList',
        component: () => import('@/views/coupon/CouponTemplateList.vue'),
        meta: { 
          title: '优惠券模板管理',
          requiresAuth: true 
        }
      },
      {
        path: 'coupons/templates/create',
        name: 'CouponTemplateCreate',
        component: () => import('@/views/coupon/CouponTemplateForm.vue'),
        meta: { 
          title: '新增优惠券模板',
          requiresAuth: true 
        }
      },
      {
        path: 'coupons/templates/:id/edit',
        name: 'CouponTemplateEdit',
        component: () => import('@/views/coupon/CouponTemplateForm.vue'),
        meta: { 
          title: '编辑优惠券模板',
          requiresAuth: true 
        }
      },
      {
        path: 'coupons/issue',
        name: 'CouponIssue',
        component: () => import('@/views/coupon/CouponIssue.vue'),
        meta: { 
          title: '优惠券发放',
          requiresAuth: true 
        }
      },
      // 轮播图管理路由
      {
        path: 'banners',
        name: 'BannerList',
        component: () => import('@/views/banner/BannerList.vue'),
        meta: { 
          title: '轮播图管理',
          requiresAuth: true 
        }
      },
      {
        path: 'banners/create',
        name: 'BannerCreate',
        component: () => import('@/views/banner/BannerForm.vue'),
        meta: { 
          title: '新增轮播图',
          requiresAuth: true 
        }
      },
      {
        path: 'banners/:id/edit',
        name: 'BannerEdit',
        component: () => import('@/views/banner/BannerForm.vue'),
        meta: { 
          title: '编辑轮播图',
          requiresAuth: true 
        }
      },
      // 公告管理路由
      {
        path: 'announcements',
        name: 'AnnouncementList',
        component: () => import('@/views/announcement/AnnouncementList.vue'),
        meta: { 
          title: '公告管理',
          requiresAuth: true 
        }
      },
      {
        path: 'announcements/create',
        name: 'AnnouncementCreate',
        component: () => import('@/views/announcement/AnnouncementForm.vue'),
        meta: { 
          title: '新增公告',
          requiresAuth: true 
        }
      },
      {
        path: 'announcements/:id/edit',
        name: 'AnnouncementEdit',
        component: () => import('@/views/announcement/AnnouncementForm.vue'),
        meta: { 
          title: '编辑公告',
          requiresAuth: true 
        }
      },
      // 用户管理路由
      {
        path: 'users',
        name: 'UserList',
        component: () => import('@/views/user/UserList.vue'),
        meta: { 
          title: '用户管理',
          requiresAuth: true 
        }
      },
      // 会员等级管理路由
      {
        path: 'membership-levels',
        name: 'MembershipLevelList',
        component: () => import('@/views/membershipLevel/MembershipLevelList.vue'),
        meta: { 
          title: '会员等级管理',
          requiresAuth: true 
        }
      },
      {
        path: 'membership-levels/create',
        name: 'MembershipLevelCreate',
        component: () => import('@/views/membershipLevel/MembershipLevelForm.vue'),
        meta: { 
          title: '新增会员等级',
          requiresAuth: true 
        }
      },
      {
        path: 'membership-levels/:id/edit',
        name: 'MembershipLevelEdit',
        component: () => import('@/views/membershipLevel/MembershipLevelForm.vue'),
        meta: { 
          title: '编辑会员等级',
          requiresAuth: true 
        }
      },
      {
        path: 'membership-levels/:id/detail',
        name: 'MembershipLevelDetail',
        component: () => import('@/views/membershipLevel/MembershipLevelForm.vue'),
        meta: { 
          title: '会员等级详情',
          requiresAuth: true 
        }
      },
      // 证书生成页面 - 只能通过门店详情访问
      {
        path: 'system/certificates',
        name: 'CertificateGeneration',
        component: () => import('@/views/system/CertificateGeneration.vue'),
        meta: { 
          title: '授权证书生成',
          requiresAuth: true,
          hideInMenu: true // 隐藏在菜单中，只能通过程序跳转访问
        }
      }
    ]
  },
  // 用户端门店相关路由
  {
    path: '/store-center',
    name: 'StoreCenter',
    component: () => import('@/views/store/StoreCenter.vue'),
    meta: { 
      title: '门店中心',
      requiresAuth: true 
    }
  },
  {
    path: '/store-application',
    name: 'StoreApplication',
    component: () => import('@/views/store/StoreApplication.vue'),
    meta: { 
      title: '门店申请',
      requiresAuth: true 
    }
  },
  {
    path: '/my-applications',
    name: 'MyApplications',
    component: () => import('@/views/store/MyApplications.vue'),
    meta: { 
      title: '我的申请',
      requiresAuth: true 
    }
  },
  {
    path: '/my-stores',
    name: 'MyStores',
    component: () => import('@/views/store/MyStores.vue'),
    meta: { 
      title: '我的门店',
      requiresAuth: true 
    }
  },
  {
    path: '/my-stores/:id',
    name: 'MyStoreDetail',
    component: () => import('@/views/store/StoreDetail.vue'),
    meta: { 
      title: '门店详情',
      requiresAuth: true 
    }
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.getters.token
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/')
  } else {
    next()
  }
})

export default router 